module.exports = __webpack_public_path__ + "static/img/cs.dc8e710.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cs.jpg
// module id = caac
// module chunks = 1